import styles from "../../styles/Login.module.css";
import { regexAoMenos1CaracterEspecial, regexAoMenos1LetraMaiuscula, regexAoMenos1LetraMinuscula, regexAoMenos1Numero, regexMinimo8Caracteres } from "../utils/Utils";

export default function BoxPadraoSenha({ values, name = "password" }) {
    const compararRequisitoSenha = (regex) => regex.test(values[name]);

    return (
        <>
            <p className={styles.textoSenhaRequisitos}>Sua senha deve conter:</p>

            <div className={styles.boxSenha}>
                <div className={styles.senhaRequisitos}>
                    <p style={{ color: compararRequisitoSenha(regexMinimo8Caracteres) ? "#222222" : "#777777" }}>No mínimo 8 caracteres</p>

                    {compararRequisitoSenha(regexMinimo8Caracteres) && <img src="/images/check-green.png" alt="Requisito atendido" />}
                </div>

                <div className={styles.senhaRequisitos}>
                    <p style={{ color: compararRequisitoSenha(regexAoMenos1LetraMinuscula) ? "#222222" : "#777777" }}>Ao menos 1 letra minúscula</p>

                    {compararRequisitoSenha(regexAoMenos1LetraMinuscula) && <img src="/images/check-green.png" alt="Requisito atendido" />}
                </div>

                <div className={styles.senhaRequisitos}>
                    <p style={{ color: compararRequisitoSenha(regexAoMenos1LetraMaiuscula) ? "#222222" : "#777777" }}>Ao menos 1 letra maiúscula</p>

                    {compararRequisitoSenha(regexAoMenos1LetraMaiuscula) && <img src="/images/check-green.png" alt="Requisito atendido" />}
                </div>

                <div className={styles.senhaRequisitos}>
                    <p style={{ color: compararRequisitoSenha(regexAoMenos1Numero) ? "#222222" : "#777777" }}>Ao menos 1 número (0123456789)</p>

                    {compararRequisitoSenha(regexAoMenos1Numero) && <img src="/images/check-green.png" alt="Requisito atendido" />}
                </div>

                <div className={styles.senhaRequisitos}>
                    <p style={{ color: compararRequisitoSenha(regexAoMenos1CaracterEspecial) ? "#222222" : "#777777" }}>Ao menos 1 caractere especial (*\!@#$%&/+-=)</p>

                    {compararRequisitoSenha(regexAoMenos1CaracterEspecial) && <img src="/images/check-green.png" alt="Requisito atendido" />}
                </div>
            </div>
        </>
    );
}
